/* global pe */

/**
 * infobip自訂方法
 */

export default (context, inject) => {
  const infobipSetUser = () => {
    if (context.$auth.loggedIn) {
      if (typeof pe !== 'undefined' && pe) {
        const {
          APhone
        } = context.$auth.user
        pe.setPerson({ phone: `+8869${APhone.substring(2)}` })
      }
    } else {
      if (typeof pe !== 'undefined' && pe) {
        pe.forgetPerson()
      }
    }
  }

  const infobipForgetUser = () => {
    if (typeof pe !== 'undefined' && pe) {
      pe.forgetPerson()
    }
  }

  const infobipTrackEvent = (name, attr) => {
    if (typeof pe !== 'undefined' && pe) {
      pe.track(name, attr)
    }
  }

  inject('infobipSetUser', infobipSetUser)
  inject('infobipForgetUser', infobipForgetUser)
  inject('infobipTrackEvent', infobipTrackEvent)

  /**
   * script設定檔 目前透過 GTM 進行引入
   * 僅於本地開發且 client 端自動插入 script
   */
  if (process.env.NODE_ENV === 'development' && process.client) {
    if (typeof window !== 'undefined' && !window.pe) {
      const script = document.createElement('script')
      script.async = true
      script.src = 'https://s3.eu-central-1.amazonaws.com/portal-cdn-production/people-events-sdk/pe.latest-2.js'
      script.onload = () => {
        if (window.pe) {
          window.pe.init('0c5cf67b474c8246bb920df174fcafde-82b1f4ae-4b5a-43be-b3d6-274dd72a1bef')
        }
      }
      document.head.appendChild(script)
    }
  }
}
